module.exports = __webpack_public_path__ + "static/media/BIMbg.02c6ccc3.png";